import type { FilterOptions } from './build-filter-options'

// Facet value → localized display label, flattened across every axis. Labels
// are localized upstream (server t() for the controlled vocabularies, the
// out-of-band translation cache for feature names), so the row chips and the
// active-filter pills can look a value up without knowing its axis.
export const buildFacetLabels = (filterOptions: FilterOptions): Map<string, string> => {
  const labels = new Map<string, string>()
  const axes = [
    filterOptions.classification,
    filterOptions.style,
    filterOptions.loss,
    filterOptions.tags,
    filterOptions.channels,
    filterOptions.hardware,
    filterOptions.software,
    filterOptions.accessories,
    filterOptions.brands,
  ]
  for (const options of axes) {
    for (const option of options) {
      if (option.label && !labels.has(option.value)) {
        labels.set(option.value, option.label)
      }
    }
  }
  return labels
}
